import { useStatsigDynamicLocaleConfig } from '@src/experiments/statsig-integration/use-statsig-dynamic-locale-config.hook'

/**
 * The web-pdp-review-system-v3 experiment has concluded with groupC winning.
 * This hook now returns the winning behavior (showReviewSummaryAndFilterTags)
 * based on locale configuration only.
 */
export default function useReviewSystemV3Experiment(): {
  showReviewSummary: boolean
  showReviewFilterTags: boolean
  showReviewSummaryAndFilterTags: boolean
} {
  const { reviewSystemV3Enabled = false } = useStatsigDynamicLocaleConfig()

  return {
    showReviewSummary: false,
    showReviewFilterTags: false,
    showReviewSummaryAndFilterTags: reviewSystemV3Enabled,
  }
}
